// extracted by mini-css-extract-plugin
export const button = "button-module--button--27OuJ";
export const solid = "button-module--solid--3JxXX";
export const ghost = "button-module--ghost--PHuG_";
export const bare = "button-module--bare--3Oig-";
export const isSelected = "button-module--is-selected--gzYle";
export const small = "button-module--small--rmD8C";